export class CuentaContabilidad {
    loacs: string;
    ACCOUNT_ID: number;
    PARENT_ACCOUNT_ID: number;
    NUMBER: string;
    NAME: string;
    NIVEL: number;
    AFFECTABLE: any;
    DEBTOR: any; //Naturaleza
    CREATION_DATE: any;
    LAST_UPDATE_DATE: any;
    ACCOUNT_SAT_ID: number;
    RANGE_ACCOUNT_ID: number;
    DIRECT_PARENT_ACCOUNT_ID: number;
}


// WEBPACK FOOTER //
// ./src/app/models/cuenta-contabilidad.ts